import { render, staticRenderFns } from "./GroupEditModal.vue?vue&type=template&id=b933c716&scoped=true&lang=pug"
import script from "./GroupEditModal.vue?vue&type=script&lang=js"
export * from "./GroupEditModal.vue?vue&type=script&lang=js"
import style0 from "./GroupEditModal.vue?vue&type=style&index=0&id=b933c716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b933c716",
  null
  
)

export default component.exports